import { render, staticRenderFns } from "./ScenicJingquKoubei.vue?vue&type=template&id=01f4fab1&scoped=true&"
import script from "./ScenicJingquKoubei.vue?vue&type=script&lang=js&"
export * from "./ScenicJingquKoubei.vue?vue&type=script&lang=js&"
import style0 from "./ScenicJingquKoubei.vue?vue&type=style&index=0&id=01f4fab1&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01f4fab1",
  null
  
)

export default component.exports